<template>
  <div class="new-form">
    <widget title="Başvuru Girişi">

      <div class="step-bar">
        <el-steps  :active="step" align-center >
          <el-step title="Başvuru Tipi" ></el-step>
          <el-step title="Kullanıcı Bilgileri" ></el-step>
          <el-step title="Adres Bilgileri" ></el-step>
          <el-step title="TT Başvuru Bilgileri" ></el-step>
          <el-step title="Ek Servis ve Hizmetler" ></el-step>
        </el-steps>
      </div>

      <hr/>
      <div style="height: 20px;"></div>


      <!-- Step 1 -->

      <div class="" v-show="step===1">
        <div class="text-center">
          <label>Başvuru Tipi</label><br/>
          <el-select v-model="form.type">
            <el-option v-for="type in types" :key="type.value" :label="type.label" :value="type.value"></el-option>
          </el-select>
        </div>
      </div>

      <!-- Step 2 Bireysel Kullanıcı Bilgilleri-->

      <div class="" v-show="step===2 && (form.type===1 || form.type===3)">
        <div class="row">
          <div class="col-12">
            <label>Tc Kimlik Numarası / Yabancı Kimlik Numarası</label>
            <el-input v-model="form.identifyNumber"></el-input>
          </div>
          <div class="col-6">
            <label>İsim</label>
            <el-input v-model="form.name"></el-input>
          </div>
          <div class="col-6">
            <label>Soyisim</label>
            <el-input v-model="form.surname"></el-input>
          </div>
          <div class="col-6">
            <label>Bağlantı Yeri</label> <br/>
            <el-switch v-model="form.place.home"></el-switch>
            Ev
            <el-switch v-model="form.place.work"></el-switch>
            İş <br/>
          </div>
          <div class="col-6">
            <label>Sabit Telefon</label> <br/>
            <el-input v-model="form.phone"></el-input>
          </div>
          <div class="col-12">
            <label>Yalın İnternet</label> <br/>
            <el-switch v-model="form.leanLine"></el-switch>
          </div>
        </div>
      </div>

      <!-- Step 3 Bireysel Adres Bilgileri-->

      <div class="" v-show="step===3 && (form.type===1 || form.type===3)">
        <div class="row">
          <div class="col-6">
            <label>Şehir</label>
            <el-input v-model="form.address.city"></el-input>
          </div>
          <div class="col-6">
            <label>İlçe</label>
            <el-input v-model="form.address.state"></el-input>
          </div>
          <div class="col-6">
            <label>Bucak</label>
            <el-input v-model="form.address.district"></el-input>
          </div>
          <div class="col-6">
            <label>Mahalle</label>
            <el-input v-model="form.address.neighborhood"></el-input>
          </div>
          <div class="col-6">
            <label>Cadde Sokak</label>
            <el-input v-model="form.address.street"></el-input>
          </div>
          <div class="col-6">
            <label>Bina</label>
            <el-input v-model="form.address.mainNumber"></el-input>
          </div>
          <div class="col-6">
            <label>Dari No</label>
            <el-input v-model="form.address.doorNumber"></el-input>
          </div>
        </div>
      </div>

      <div class="bottom" style="margin-top:30px;">
        <hr/>
        <div class="row">
          <div class="col">
            <el-button size="small" type="primary" @click="step--"><i class="fa fa-backward"></i> Geri</el-button>
          </div>
          <div class="col text-right">
            <el-button size="small" type="primary" @click="step++">İleri <i class="fa fa-forward"></i></el-button>
          </div>
        </div>
      </div>

    </widget>
  </div>

</template>

<script>
  export default {
    name: "List",
    data() {
      return {
        step: 1,
        form: {
          type: null,
          identifyNumber: null,
          name: null,
          surname: null,
          place: {
            home: false,
            work: false
          },
          phone: null,
          leanLine: null,
          address: {
            city: null,
            state: null,
            district: null,
            neighborhood: null,
            street: null,
            mainNumber: null,
            doorNumber: null
          }
        },
        types: [
          {
            label: 'Bireysel',
            value: 1
          },
          {
            label: 'Kurumsal',
            value: 2
          },
          {
            label: 'Yabancı Uyruklu',
            value: 3
          },


        ]
      }
    },
    created() {

    }
  }
</script>

<style scoped lang="scss">
  .new-form {
    div[class^="col"] {
      margin-top: 5px;
      margin-bottom: 5px;
      border-bottom: 1px dotted #efefef;
      padding-bottom: 5px;
    }

    label {
      font-weight: bold;
    }
  }

  .step-bar {
    margin-top: 20px;
    margin-bottom: 40px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/BundleApplication/Page/Application.vue